module.exports = __webpack_public_path__ + "static/img/campaign-detail.f81f641.png";